import { Indicator } from '@radix-ui/react-progress';

import { ProgessIndicatorProps } from './Progress.types';

export function ProgressIndicator({ value }: ProgessIndicatorProps) {
  return (
    <Indicator
      className={`h-full w-full flex-1 ${getBackgroundClass(value)} transition-all`}
      style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
    />
  );
}

function getBackgroundClass(value?: number | null) {
  const normalizedValue = value || 0;

  if (normalizedValue < 50) {
    return 'bg-red-500';
  } else if (normalizedValue < 80) {
    return 'bg-yellow-500';
  } else {
    return 'bg-teal-500';
  }
}
